import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../../components/ButtonComponent";
import AddIcon from "@mui/icons-material/Add";
import SetCalendarModal from "./setCalendarModal";
// import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import { COLORS } from "../../../lib/colors";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import * as HTTPServices from "../../../api/HTTPServices";
import * as Toast from "../../../lib/toast";

import classes from "./index.module.scss";

let counter = 0;
function createData(key, date, time, capacity, reservation, price, type) {
  if (type === 1) {
    type = "ordinary";
  } else if (type === 2) {
    type = "express";
  } else if (type === 3) {
    type = "offlline";
  }
  counter += 1;
  return { id: counter, key, date, time, capacity, reservation, price, type };
}

function createKeys(key) {
  return key;
}

export default function Index() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const onSelectItem = (data) => {
  //   // console.log(`selectedRow`, selectedRow);
  //   selectedItems.push(data.data.key);
  //   setSelectedRow(selectedItems);
  // };

  const onSelectionModelChange = (e) => {
    const selectedIDs = e.selectionModel;
    let existItem = data.filter((item) => selectedIDs.includes(item.id));
    let selectedItems = [];
    existItem.map(function (item) {
      selectedItems.push(createKeys(item.key));
      return selectedItems;
    });
    setSelectedRowKeys(selectedItems);
    console.log("selectedItems", selectedItems);
  };

  const deleteItems = () => {
    const params = new URLSearchParams();
    params.append("delete_items", JSON.stringify(selectedRowKeys));

    const RequestService = HTTPServices.postMethod(
      "calender",
      params,
      "true",
      "delete"
    );
    RequestService.then(function (response) {
      if (response) {
        Toast.SuccessData("Items were successfully deleted،");
        setSelectedRowKeys([]);
        updateData(response);
      }
    });
  };

  useEffect(() => {
    const RequestService = HTTPServices.getMethod("calender", "", "true");
    RequestService.then(function (response) {
      if (response) {
        let data = [];
        response.map(function (item) {
          let time = parseInt(item.time) + 1;
          if (item.time === 0) {
            time = 24 + " till " + time;
          } else {
            time = item.time + " till " + time;
          }
          data.push(
            createData(
              item.key,
              item.fa_data,
              time,
              item.capacity,
              item.reservation,
              item.price,
              item.type
            )
          );
          return data;
        });
        setData(data);
      }
    }).catch(function (error) {});
  }, []);

  const updateData = (response) => {
    var data = [];
    response.map(function (item) {
      var time = parseInt(item.time) + 1;
      time = item.time + " till " + time;

      data.push(
        createData(
          item.key,
          item.fa_data,
          time,
          item.capacity,
          item.reservation,
          item.price,
          item.type
        )
      );
      return data;
    });

    setData(data);
  };

  return (
    <div>
      <h3 className={classes.title}>
        {t("pages.protectedPages.setCalendar.title")}
      </h3>
      <hr></hr>
      <div className={classes.addBtn}>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.purple}
          textColor={COLORS.white}
          onClick={() => setOpen(true)}
          icon={<AddIcon width={30} height={30} />}
        >
          {t("pages.protectedPages.setCalendar.setVisitTime")}
        </ButtonComponent>
      </div>

      <div className={classes.tableDiv}>
        {selectedRowKeys.length === 0 && (
          <p>{t("pages.protectedPages.setCalendar.deleteRow")}</p>
        )}
        {selectedRowKeys.length > 0 && (
          <p>
            {`${selectedRowKeys.length} items are selected to remove hit the trash `}
          </p>
        )}
        {selectedRowKeys.length > 0 && (
          <DeleteForeverIcon
            color="error"
            fontSize="large"
            onClick={deleteItems}
          />
        )}
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={data}
            columns={columns}
            pageSize={5}
            checkboxSelection
            // onRowSelected={(data) => {
            //   onSelectItem(data);
            // }}
            onSelectionModelChange={(e) => onSelectionModelChange(e)}
          />
        </div>
      </div>
      <SetCalendarModal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        updateData={updateData}
      />
    </div>
  );
}

const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "date", numeric: false, headerName: "date", width: 130 },
  { field: "time", numeric: false, headerName: "time", width: 130 },
  {
    field: "capacity",
    numeric: false,
    headerName: "capacity",
    width: 130,
  },
  {
    field: "reservation",
    numeric: false,
    headerName: "reserved",
    width: 130,
  },
  {
    field: "price",
    numeric: false,
    headerName: "price",
    width: 130,
  },
  {
    field: "type",
    numeric: false,
    headerName: "visit type",
    width: 130,
  },
];
